'use client'

import { PriceRecurringInterval } from 'database'
import React, { useContext, useState } from 'react'

export interface PricingContext {
  recurringInterval: PriceRecurringInterval
  onChangeRecurringInterval: (interval: PriceRecurringInterval) => void
}

const PricingContext = React.createContext<PricingContext | undefined>(
  undefined
)

export const usePricing = () => useContext(PricingContext)!

export const PricingProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [recurringInterval, setRecurringInterval] =
    useState<PriceRecurringInterval>('month')

  return (
    <PricingContext.Provider
      value={{
        recurringInterval,
        onChangeRecurringInterval: setRecurringInterval,
      }}
    >
      {children}
    </PricingContext.Provider>
  )
}
